import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
function MainContainer(props) {
  const { children } = props;
  return (
    <>
      <main className="main__container">
        <section className="main__content">
          <div className="container">{children}</div>
        </section>
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          draggable
        />
      </main>
    </>
  );
}

export default MainContainer;
